import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticleGrid from './components/ArticleGrid';
import FeatureGrid from './components/FeatureGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import SEOHead from '@/components/base/SEOHead';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = 'https://oopbuyspread.biz';

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'OOPBUY Spreadsheet Deutschland',
  url: siteUrl,
  description: 'Der umfassende OOPBUY Spreadsheet Guide für Deutschland, Österreich und die Schweiz. Alle Kategorien, Tipps und Vergleiche für sicheres Online-Shopping.',
  inLanguage: 'de-DE',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'OOPBUY Spreadsheet',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
  description: 'OOPBUY Spreadsheet ist die führende deutschsprachige Informationsplattform für sicheres Shopping auf Taobao, Weidian und 1688.',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'DE',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['German'],
  },
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="OOPBUY Spreadsheet Deutschland – Der komplette Guide 2026"
        description="OOPBUY Spreadsheet Deutschland 2026: Der umfassende Guide für deutsche Käufer. Entdecken Sie Kategorien wie Schuhe, Hoodies, T-Shirts, Jacken und mehr. Sicher einkaufen mit OOPBUY Spreadsheet – Ihr vertrauenswürdiger Einkaufsassistent für den DACH-Raum."
        keywords="OOPBUY Spreadsheet, OOPBUY Spreadsheet Deutschland, OOPBUY Spreadsheet Guide, OOPBUY Spreadsheet Deutsch, OOPBUY Spreadsheet 2026, OOPBUY, Spreadsheet Shopping"
        canonicalUrl="https://oopbuyspread.biz/"
        robots="index, follow"
      />
      <JsonLd data={webSiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ArticleGrid />
        <FeatureGrid />
        <TestimonialSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}